.carousel {
    height: 260px;
    margin: 0px 35px 20px;
}